<template>
  <highcharts class="perf-chart" style="margin: auto; height: 100%; width: 100%;" :options="chartOption" ref="highchart"/>
</template>

<script>
import { cloneDeep, map, isEmpty } from 'lodash';

import { chartColorSet } from '@/constants/chart-options';
import { LINE_CHART_OPTION, PIE_CHART_OPTION } from '@/constants/topologymap-major-info';
import { convertValuByUnit } from '@/utils/number';
import { routePathByObjEventHist } from '@/utils/router';

export default {
  name: 'WCommonChart',
  props: {
    chartType: {
      type: String,
      default: 'LINE',
    },
  },
  data() {
    return {
      chartOption: cloneDeep(LINE_CHART_OPTION),
      chartData: [],
      LINE_CHART_OPTION,
      PIE_CHART_OPTION,
    };
  },
  watch: {
    chartType: {
      immediate: true,
      handler(type) {
        if (!isEmpty(type)) {
          this.chartOption = cloneDeep(this[`${type}_CHART_OPTION`]);
        }
      },
    },
  },
  methods: {
    /**
     * 데이터 초기화 (요청데이터)
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} newData [description]
     */
    setData(newData) {
      this.chartData = newData || [];
      this.chartOption.series = newData || [];
      this.$nextTick(() => {
        this.drawChart();
      });
    },
    /**
     * 차트 draw
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    drawChart() {
      // 배경색상
      this.chartOption.chart.plotBackgroundColor = 'rgba(255, 255, 255, 0)';

      // 선 색상

      let colorSet = cloneDeep(chartColorSet);
      this.chartOption.colors = colorSet;
      const vm = this;

      if (this.chartType === 'LINE') {
        colorSet = map(colorSet, (color) => this.Highcharts.Color(color).setOpacity(0.5).get());
        this.chartOption.tooltip.style = {
          fontSize: '10px',
          width: '50px',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        };
        this.chartOption.tooltip.formatter = function tooltipFormatter() {
          let s = '';
          this.points.forEach((value) => {
            const convertedValue = convertValuByUnit(value.y, isEmpty(value.series.userOptions.rscInfo) ? '' : value.series.userOptions.rscInfo.rscUnit, true, null, true);
            s += `<span style="color:${value.color}">\u25CF</span>`;
            s += ` ${convertedValue}`;
          });
          return s;
        };
        this.chartOption.plotOptions.series = {
          cursor: 'pointer',
          events: {
            click(e) {
              const objInfo = e.point.series.userOptions.rscInfo;
              const objId = objInfo.managetypeId === 'E2E' ? objInfo.rscKey.split('.')[1] : objInfo.objId;
              routePathByObjEventHist(vm, objId, null, e.point.category, null, true);
            },
          },
          marker: {
            enabled: false,
          },
        };
      } else {
        this.chartOption.tooltip.style = {
          fontSize: '8px',
          width: '50px',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        };
        this.chartOption.tooltip.formatter = function tooltipFormatter() {
          let s = '';
          if (!isEmpty(this.point.series.userOptions.rscInfo)) {
            const convertedValue = convertValuByUnit(this.point.y, this.point.unit, true, null, true);
            s += `${this.point.objName}<br />`;
            s += `<span style="color:${this.point.color}">\u25CF</span>`;
            s += ` ${convertedValue}`;
          } else {
            s = `<span style="color:${this.point.color}">\u25CF</span>`;
            s += `${this.point.name}: ${this.point.y}`;
          }

          return s;
        };
      }

      this.resize();
    },
    /**
     * 차트 리사이즈
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    resize() {
      this.$refs.highchart.chart.reflow();
    },
  },
};
</script>
<style lang="scss">
.perf-chart-wrapper {
  .perf-label,
  .perf-status {
    width: 100%;
    text-align: center;
  }
  .perf-status {
    display: grid;
    color: #4D90FA;
    font-size: 14px;
  }
  .perf-label {
    font-size: 12px;
    line-height: 12px;
    color: #666;
    span {
      padding: 3px 10px;
      background-color: #EEEEEE;
      border-radius: 10px;
    }
  }

  .highcharts-label.highcharts-tooltip {
    span {
      font-size: 5px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/components/CommonChart.vue